import SvgIcon from '@mui/material/SvgIcon';

/**
 * The Analyst Institute's logo mark (axes, the curve, and the dashed line through it) as a
 * single-color 24x24 icon, so it sits in the sidebar like the MUI nav icons and takes the
 * nav's colors (currentColor) — grey normally, the accent color when selected. Built with
 * SvgIcon, same as the BigQueryIcon in Hart's UserAdministration.
 */
export default function AnalystInstituteIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeLinecap="butt">
        {/* Axes */}
        <path d="M3 3.5V21H20.5" strokeWidth="1.8" />
        {/* The curve */}
        <path d="M6 19C7.2 10 8.8 5 11.25 5S15.3 10 16.5 19" strokeWidth="2.2" />
        {/* Dashed line through it */}
        <path d="M4.5 13.25H18.5" strokeWidth="1.3" strokeDasharray="1.6 1.2" />
      </g>
      {/* Arrowheads */}
      <path d="M3 1L5.2 4H0.8Z" />
      <path d="M23 21L20 23.2V18.8Z" />
    </SvgIcon>
  );
}
